export enum PayType {
    EZY_PAY_12 = "EZY_PAY_12",
    EZY_PAY_6 = "EZY_PAY_6",
    FPX = "FPX",
    AMEX = "AMEX",
    CARD = "CARD",
}
